import * as React from 'react';

import { FormParserContext } from 'src/contexts/form.context';

import { SecondaryButton } from 'src/components/Button';
import { Factory } from 'src/components/Factory';

import styles from './UploadPictureButton.module.scss';

const UploadDialog = React.lazy(() => import('./UploadDialog'));

export function UploadPictureButton() {
  const { script } = React.useContext(FormParserContext);

  const [isOpen, setIsOpen] = React.useState(false);

  function handleOnClick() {
    setIsOpen(state => !state);
  }

  function handleOnDragover() {
    setIsOpen(true);
  }

  function renderUploadDialog() {
    return (
      <Factory>
        <UploadDialog accept='image/*' />
      </Factory>
    );
  }

  return (
    <div className={styles.container} onDragOver={handleOnDragover}>
      {isOpen && renderUploadDialog()}
      <SecondaryButton isSmall isPrevent rightIconId='add' onClick={handleOnClick} label={script.buttonLabel} />
    </div>
  );
}
